import { Status } from 'civic-champs-shared/api/hooks/fetchRefactoredSchema'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import { TableSortByResponse } from 'core/table/interfaces/TablePersistence'

export const useGetTableSortBy = (): [
  (tableName: string) => Promise<TableSortByResponse>,
  Status<TableSortByResponse>,
] => {
  const [request, status] = useFetchRefactored<TableSortByResponse>({
    emptyValue: undefined,
  })

  const fetchTableSortBy = useCallback(
    tableName =>
      request({
        method: 'get',
        url: `/user/tables/${tableName}/sort-by`,
      }),
    [request],
  )

  return [fetchTableSortBy, status]
}

export default useGetTableSortBy
